import * as Sentry from '@sentry/react';
import { Tokens } from './types/Tokens';

export const isTokenValid = (): boolean => {
  const tokens = getTokens();
  if (tokens && tokens.accessToken && tokens.expiresAt) {
    const tokenExpiryTime = new Date(tokens.expiresAt).getTime();
    const currentTime = new Date().getTime();
    const tokenValidFor = tokenExpiryTime - currentTime;
    Sentry.addBreadcrumb({
      data: { tokenValidFor, tokenExpiryTime, currentTime },
      level: Sentry.Severity.Info
    });
    return tokenValidFor > 0;
  }
  return false;
};

export const putTokens = (tokens: Tokens | null): void => {
  if (typeof tokens === 'object' && tokens !== null) {
    localStorage.setItem('tokens', JSON.stringify(tokens));

    const tokenExpiryTime = new Date(tokens!.expiresAt!);
    document.cookie = `titoken=${
      tokens.accessToken
    };Path=/collectors/icons/;max-age=3600;expires=${tokenExpiryTime.toUTCString()};SameSite=Strict;Secure`;
  } else {
    localStorage.removeItem('tokens');
    document.cookie =
      'titoken=;Path=/collectors/icons/;max-age=3600;SameSite=Strict;Secure';
  }
};

export const getTokens = (): Tokens | null => {
  const json = localStorage.getItem('tokens');
  if (!json) {
    return null;
  }
  let tokens = null;

  try {
    tokens = JSON.parse(json);
  } catch (e) {
    localStorage.removeItem('tokens');
    document.cookie =
      'titoken=;Path=/collectors/icons/;max-age=3600;SameSite=Strict;Secure';
  }

  return tokens;
};

export function getParsedJwt(token?: string): any {
  if (!token) return undefined;
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return undefined;
  }
}
